import { css, styled } from '@helvetia/components/theme'
import {
  HorizontalMarginProps,
  horizontalMarginsCss,
  VerticalMarginProps,
  verticalMarginsCss,
} from '@helvetia/components/theme/css'
import { sizes } from '@helvetia/components/theme/size'
import { rem } from 'polished'

import { ReactComponent as CalendarSVG } from './calendar.svg'
import { ReactComponent as DeductibleSVG } from './deductible.svg'
import { ReactComponent as InsuredSVG } from './insured.svg'
import { ReactComponent as LiabilitySVG } from './legal.svg'
import { ReactComponent as LocationSVG } from './locationScope.svg'
import { ReactComponent as TypeGoodsSVG } from './typeOfGoods.svg'
import { ReactComponent as UserSVG } from './user.svg'
import { ReactComponent as VehicleSVG } from './vehicles.svg'

export const VehiclesIcon = styled(VehicleSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
  align-self: baseline;
`
export const SumInsuredIcon = styled(InsuredSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const DeductibleIcon = styled(DeductibleSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const LocationScopeIcon = styled(LocationSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const TypeGoodsIcon = styled(TypeGoodsSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const LiabilityIcon = styled(LiabilitySVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const CalendarIcon = styled(CalendarSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const UserIcon = styled(UserSVG)`
  flex: none;
  width: ${rem(sizes.s)};
  height: ${rem(sizes.s)};
  margin-right: ${rem(sizes.xxs)};
`

export const PencilIcon = styled.img.attrs({})<{ src: string }>`
  src: ${p => p.src};
  width: ${rem(sizes.xs)};
  height: ${rem(sizes.xs)};
  margin-left: ${rem(sizes.xxs)};
  cursor: pointer;
`

export const DeleteIcon = styled.img.attrs({})<{ src: string }>`
  src: ${p => p.src};
  align-self: center;
  width: ${rem(sizes.xs)};
  height: ${rem(sizes.xs)};
  cursor: pointer;
`

export const ClickableIcon = styled.img.attrs({})<
  { src: string } & HorizontalMarginProps & VerticalMarginProps
>`
  ${horizontalMarginsCss};
  ${verticalMarginsCss};

  ${p =>
    p.marginRight &&
    css`
      &:not(:last-child) {
        margin-right: ${p.marginRight};
      }
    `};
  src: ${p => p.src};
  display: flex;
  align-self: baseline;
  width: ${rem(sizes.xs)};
  height: ${rem(sizes.xs)};
  cursor: pointer;
`

export const MainIcon = styled.div`
  display: flex;
`
